import { useState, useEffect } from "react";
import { useRelocateSettingHooks } from "../../utils/SettingUtils";
import Box from "../Box";
import AlertBox from "../AlertBox";
import { updateSettingByKey } from "../../api/setting";
import { useControlPermission } from "../../utils/ActionPermissionUtils";

export default function BoxSettingRelocate() {
  let { hasAccess } = useControlPermission();

  let { data, fetched, loading: dataLoading, getRelocateSetting } = useRelocateSettingHooks();
  let [alert, setAlert] = useState({ show: false, message: "", type: "" });
  let [form, setForm] = useState({});
  let [loading, setLoading] = useState(false);

  useEffect(() => {
    if (fetched) {
      let defaultForms = {
        value: data.value,
      };
      setForm(defaultForms);
    }
  }, [fetched, data]);

  const sendData = async (form) => {
    setLoading(true);
    try {
      let response = await updateSettingByKey("relocate-fee", form);
      setAlert({ show: true, message: response.data.message, type: "success" });
      getRelocateSetting();
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }
      setAlert({ show: true, message, type: "danger" });
    }
    setLoading(false);
  };

  const submitData = (event) => {
    event.preventDefault();

    let formData = {};
    formData["relocate-fee"] = form.value;

    sendData(formData);
  };

  const changeValueForm = (key, value) => {
    let tempForm = { ...form };
    tempForm[key] = value;
    setForm(tempForm);
  };

  return (
    <Box title="Setting Biaya Relokasi" loading={dataLoading || loading}>
      <AlertBox {...alert} setAlert={setAlert} />
      <form onSubmit={(event) => submitData(event)}>
        <div className="form-group">
          <label>Biaya Relokasi</label>
          <input
            type="number"
            min={0}
            required
            className="form-control"
            value={form.value}
            onChange={(event) => changeValueForm("value", event.target.value)}
          />
        </div>
        <div className="form-group d-flex justify-content-end">
          {hasAccess("update-setting") && (
            <button className="btn btn-primary btn-block">Simpan</button>
          )}
        </div>
      </form>
    </Box>
  );
}
